module.exports = __webpack_public_path__ + "img/Icon1.84e079ba.svg";